<template>
  <div class="progress-block">
    <div v-if="label" class="progress-label">{{ label }}</div>
    <div
      class="progress-bar"
      :aria-valuenow="clampedValue"
      aria-valuemin="0"
      aria-valuemax="100"
      role="progressbar"
    >
      <div class="progress-fill" :style="{ width: `${clampedValue}%` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    clampedValue() {
      return Math.max(0, Math.min(100, this.value))
    },
  },
}
</script>

<style scoped>
.progress-block {
  margin-top: 18px;
}

.progress-label {
  font-size: 12px;
  color: #7a8274;
}

.progress-bar {
  margin-top: 8px;
  height: 12px;
  width: 100%;
  border-radius: 999px;
  background: linear-gradient(180deg, #e8eadf 0%, #dfe4d3 100%);
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(68, 85, 38, 0.08);
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
  background: #445526;
  transition: width 0.25s ease;
}
</style>
